// extracted by mini-css-extract-plugin
module.exports = {"menu":"SGSSelect_menu__2BOhH","menuItem":"SGSSelect_menuItem__1lZX9","menuItem__selected":"SGSSelect_menuItem__selected__kS8B4"};